// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2MCyP","buttons":"SendReceipts_buttons__2Lp9S","email":"SendReceipts_email__1cUMa","bookApptTitle":"SendReceipts_bookApptTitle__3uJfV"};